import type { ReactNode } from 'react';
import { Tag, type TagSize } from '@viquard/doc-ui/components';
import { IcnBell } from '@viquard/doc-ui/icons';
import {
  formatMessage,
  useCalendarMessages,
} from '../i18n.js';
import type { CalendarEvent } from '../types.js';

export interface ReminderBadgeProps {
  readonly event: CalendarEvent;
  readonly size?: TagSize | undefined;
}

/** Compact marker for event-level reminders. `null` means the user
 *  explicitly turned reminder delivery off, so nothing is rendered. */
export function ReminderBadge(props: ReminderBadgeProps): ReactNode {
  const messages = useCalendarMessages();
  const { event, size = 'sm' } = props;
  if (event.reminderMinutesBefore === null || event.reminderMinutesBefore === undefined) {
    return null;
  }
  const px = size === 'sm' ? 11 : 13;
  return (
    <Tag tone="neutral" size={size} title={messages.composerReminderLabel}>
      <span className="vq-cal__recur-inner" aria-hidden="true">
        <IcnBell size={px} active={false} />
        <span>
          {formatMessage(messages.composerReminderMinutes, {
            count: event.reminderMinutesBefore,
          })}
        </span>
      </span>
    </Tag>
  );
}
